<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">Parámetros avanzados</div>

    <!-- BOTONES DE ESCENARIOS DE PRUEBA -->
    <div v-if="person.empresas === GLOBAL.EMPRESAS.KUBBER">
      <div class="mb-3" style="display:flex; gap:10px; flex-wrap:wrap;">
        <button class="btn btn-secondary" @click="aplicarEscenario('detecno')">
          DETECNO (demo)
        </button>
        <button class="btn btn-secondary" @click="aplicarEscenario('facturama')">
          FACTURAMA (sandbox)
        </button>
      </div>
    </div>

    <br />
    <div class="box-container">
      <div id="reporte">
        <div class="report-titulo font-oswald">
          <table width="100%">
            <tbody>
              <tr style="background-color: #e0e0e0">
                <th width="40%">PARÁMETRO</th>
                <th class="text-right">VALOR</th>
              </tr>

              <tr>
                <td>PERMISO CRE</td>
                <td class="text-right">
                  <input type="text" class="form-control" v-model="permiso_cre" />
                </td>
              </tr>

              <tr>
                <td>CÓDIGO POSTAL DE EMISIÓN</td>
                <td class="text-right">
                  <input type="text" class="form-control" v-model="codigo_postal_expedicion" />
                </td>
              </tr>

              <tr>
                <td>LUGAR DE EXPEDICIÓN</td>
                <td class="text-right">
                  <input type="text" class="form-control" v-model="lugar_expedicion" />
                </td>
              </tr>

              <tr>
                <td>RÉGIMEN FISCAL</td>
                <td class="text-right">
                  <input type="text" class="form-control" v-model="regimen" />
                </td>
              </tr>

              <tr>
                <td>TIPO DE RESPONSABILIDAD</td>
                <td class="text-right">
                  <input type="text" class="form-control" v-model="tipo_responsabilidad" />
                </td>
              </tr>

              <tr>
                <td>ZONA HORARIA</td>
                <td class="text-right">
                  <input type="text" class="form-control" v-model="zona_horaria" />
                </td>
              </tr>

              <tr>
                <td>FACTOR DE LITROS A M3</td>
                <td class="text-right">
                  <input type="text" class="form-control" v-model="factor_m3" />
                </td>
              </tr>

              <tr>
                <td>DENSIDAD GAS</td>
                <td class="text-right">
                  <input type="text" class="form-control" v-model="densidad_gnv" />
                </td>
              </tr>

              <tr>
                <td>FACTURACION ELECTRONICA: PROVEEDOR</td>
                <td class="text-right">
                  <select class="form-control" v-model="proveedor_facturas">
                    <option value=""></option>
                    <option value="detecno">DETECNO</option>
                    <option value="facturama">FACTURAMA</option>
                  </select>
                </td>
              </tr>

              <tr>
                <td>FACTURACIÓN ELECTRÓNICA: URL FACTURA</td>
                <td class="text-right">
                  <input type="text" class="form-control" v-model="url_factura" />
                </td>
              </tr>

              <tr>
                <td>FACTURACIÓN ELECTRÓNICA: LICENCIA / TOKEN</td>
                <td class="text-right">
                  <input type="text" class="form-control" v-model="licencia" />
                </td>
              </tr>

              <tr>
                <td>FACTURACIÓN ELECTRÓNICA: USUARIO API</td>
                <td class="text-right">
                  <input type="text" class="form-control" v-model="key" />
                </td>
              </tr>

              <tr>
                <td>FACTURACIÓN ELECTRÓNICA: CLAVE API</td>
                <td class="text-right">
                  <input type="text" class="form-control" v-model="pass" />
                </td>
              </tr>

              <tr>
                <td>FACTURACIÓN ELECTRÓNICA: NOMBRE EMISOR</td>
                <td class="text-right">
                  <input type="text" class="form-control" v-model="nombre_emisor" />
                </td>
              </tr>

              <tr>
                <td>FACTURACIÓN ELECTRÓNICA: CORREO RECEPCIÓN</td>
                <td class="text-right">
                  <input type="text" class="form-control" v-model="factura_electronica_correo_recepcion" />
                </td> 
              </tr>

              <tr>
                <td>FACTURACIÓN ELECTRÓNICA: LEYENDA</td>
                <td class="text-right">
                  <textarea class="form-control" v-model="factura_electronica_leyenda"
                    placeholder="Texto/leyenda que saldrá en la factura" rows="2"></textarea>
                </td>
              </tr>

              <tr>
                <td>¿EN PRODUCCIÓN?</td>
                <td class="text-left">
                  <input type="checkbox" v-model="produccion" style="transform: scale(1.5); margin-right: 10px" />
                </td>
              </tr>

              <tr>
                <td>NO CERTIFICADO</td>
                <td class="text-right">
                  <input type="text" class="form-control" v-model="no_certificado" />
                </td>
              </tr>

              <tr>
                <td>CERTIFICADO</td>
                <td class="text-right">
                  <textarea class="form-control" v-model="certificado"></textarea>
                </td>
              </tr>

              <tr>
                <td>SELLO</td>
                <td class="text-right">
                  <textarea class="form-control" v-model="sello"></textarea>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="text-right mt-4">
        <button class="btn btn-primary" @click="guardarParametros">
          Guardar Cambios
        </button>
      </div>

      <div v-if="!permiso_lista">
        {{ this.person.nombre }}, {{ this.GLOBAL.MENSAJE.SIN_AUTORIZACION }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import GLOBAL from "../../Global.js";

export default {
  data() {
    return {
      GLOBAL,
      permiso_cre: "",
      codigo_postal_expedicion: "",
      lugar_expedicion: "",
      regimen: "",
      tipo_responsabilidad: "",
      zona_horaria: "",
      factor_m3: "",
      densidad_gnv: "",
      proveedor_facturas: "",
      url_factura: "",
      licencia: "",
      key: "",
      pass: "",
      nombre_emisor: "",
      produccion: false,
      certificado: "",
      sello: "",
      no_certificado: "",
      person: {},
      permiso_lista: false,
      facturacion_horas: "",
      factura_electronica_leyenda: "",
      factura_electronica_correo_recepcion: "",
    };
  },
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    console.log("Usuario cargado:", this.person);

    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );
    this.getParametros();
  },
  methods: {
    getParametros() {
      const url = GLOBAL.API_GET_LISTA_ATRIBUTOS_EMPRESA;
      axios
        .get(url.trim(), {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: "Basic " + this.person.token,
            Environment: this.person.empresas,
          },
        })
        .then((response) => {
          const p = response.data.parametros || {};
          this.permiso_cre = p.permiso_cre || "";
          this.codigo_postal_expedicion = p.codigo_postal_expedicion || "";
          this.lugar_expedicion = p.lugar_expedicion || "";
          this.regimen = p.regimen || "";
          this.tipo_responsabilidad = p.tipo_responsabilidad || "";
          this.zona_horaria = p.zona_horaria || "";
          this.factor_m3 = p.factor_m3 || "";
          this.densidad_gnv = p.densidad_gnv || "";
          this.url_factura = p.url_factura || "";
          this.licencia = p.licencia || "";
          this.key = p.key || "";
          this.pass = p.pass || "";
          this.nombre_emisor = p.nombre_emisor || "";
          this.produccion = p.produccion || false;
          this.certificado = p.certificado || "";
          this.sello = p.sello || "";
          this.no_certificado = p.no_certificado || "";
          this.facturacion_horas = p.facturacion_horas || "";
          this.proveedor_facturas = p.proveedor_facturas || "";
          this.factura_electronica_leyenda = p.factura_electronica_leyenda || "";
          this.factura_electronica_correo_recepcion = p.factura_electronica_correo_recepcion || "";
        })
        .catch((error) => {
          console.error("Error cargando parámetros:", error);
        });
    },

    /* 🔧 NUEVO: aplicar un escenario predefinido */
    aplicarEscenario(tipo) {
      const confirmar = window.confirm(
        "Esto llenará automáticamente varios campos y puede sobrescribir valores actuales. ¿Deseas continuar?"
      );
      if (!confirmar) return;

      if (tipo === "detecno") {
        // Escenario Detecno (demo)
        this.proveedor_facturas = "detecno";
        this.codigo_postal_expedicion = "26670";
        this.url_factura = "https://detecno-factura-electronica.com/Emision/cfdiWcfEmisionServicio40_Demo/Detecno.svc";
        this.licencia = "i4ZoYqvJcyY4eytPFPZjzc8Bt5jOWKL-kOoe7AN8H7c=";
        this.nombre_emisor = "XENON INDUSTRIAL ARTICLES";
        this.key = "";   // usuario api vacío
        this.pass = "";  // clave api vacía
        // (Opcional) marcar no producción por ser demo:
        this.produccion = false;
        alert("Escenario de prueba 'Detecno (demo)' aplicado.");
      }

      if (tipo === "facturama") {
        // Escenario Facturama (sandbox)
        this.proveedor_facturas = "facturama";
        this.codigo_postal_expedicion = "44660";
        this.key = "ERICGARCIA";      // usuario
        this.pass = "3157532541";     // clave
        this.url_factura = "https://apisandbox.facturama.mx";
        this.licencia = "";
        this.nombre_emisor = "ESCUELA KEMPER URGATE";
        this.
          this.produccion = false;
        alert("Escenario de prueba 'Facturama (sandbox)' aplicado.");
      }
    },

    guardarParametros() {
      const url = GLOBAL.API_GET_LISTA_ATRIBUTOS_EMPRESA;

      const parametros = {
        permiso_cre: this.permiso_cre,
        codigo_postal_expedicion: this.codigo_postal_expedicion,
        lugar_expedicion: this.lugar_expedicion,
        regimen: this.regimen,
        tipo_responsabilidad: this.tipo_responsabilidad,
        zona_horaria: this.zona_horaria,
        factor_m3: this.factor_m3,
        densidad_gnv: this.densidad_gnv,
        url_factura: this.url_factura,
        licencia: this.licencia,
        key: this.key,
        pass: this.pass,
        nombre_emisor: this.nombre_emisor,
        produccion: this.produccion,
        certificado: this.certificado,
        sello: this.sello,
        no_certificado: this.no_certificado,
        facturacion_horas: this.facturacion_horas,
        proveedor_facturas: this.proveedor_facturas,
        factura_electronica_leyenda: this.factura_electronica_leyenda,
        factura_electronica_correo_recepcion: this.factura_electronica_correo_recepcion,
      };

      axios
        .put(
          url,
          { parametros },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: "Basic " + this.person.token,
              Environment: "this.person.empresas" in this.person ? this.person.empresas : this.person.empresa || this.person.empresas,
            },
          }
        )
        .then(() => {
          alert("Parámetros actualizados correctamente.");
        })
        .catch((error) => {
          console.error("Error al actualizar parámetros:", error);
          alert("Error al actualizar los parámetros.");
        });
    },
  },
};
</script>
